import Card from '@material-ui/core/Card';
import Chart from 'chart.js';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import Switch from '@material-ui/core/Switch';

import { v4 as uuid } from 'uuid';

import { Button } from 'react-bootstrap';
import { LazySelect } from '../ReactProtos/CellSelect';
import { LineChart, Line, YAxis, CartesianGrid } from 'recharts';

class PingGraph extends React.PureComponent {
    state = {
        data: [],
        limit: 256,
    };

    chartData = {
        type: 'line',
        data: {
            labels: [],
            datasets: [{
                label: 'one dataset',
                data: [],
            }],
        },
        options: {
            title: {
                text: 'test chart'
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    time: {
                        displayFormats: {
                            quarter: 'MMM YYYY',
                        },
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Date'
                    }
                }],
                yAxes: [{
                    scaleLabel: {
                        display: true,
                        labelString: 'value'
                    }
                }]
            },

        },
    };

    limitOptions = [
        { value: 256, label: 256 },
        { value: 512, label: 512 },
        { value: 1024, label: 1024 },
    ];

    references = {
        points: React.createRef(),
        qps: React.createRef(),
        average: React.createRef(),
        max: React.createRef(),
        min: React.createRef(),
        chart: React.createRef(),
    };

    componentDidMount() {
        if (this.references.chart.current) {
            this.chart = new Chart(this.references.chart.current, this.chartData);
        }
        this.startPing();
    }

    componentWillUnmount() {
        this.unmount = true;
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    }

    componentDidUpdate() {
        if (this.references.chart.current) {
            if (!this.chart) {
                this.chart = new Chart(this.references.chart.current, this.chartData);
            }
        } else {
            if (this.chart) {
                this.chart.destroy();
                this.chart = null;
            }
        }
    }

    startPing() {
        const start = window.performance.now();
        fetch(this.props.target)
            .then(response => response.text())
            .then(() => {
                const end = window.performance.now();
                if (!this.unmount) {
                    this.addDataPoint(end - start);
                    this.startPing();
                }
            });
    }

    addDataPoint(value) {
        let data = this.chartData.data.datasets[0].data;
        let labels = this.chartData.data.labels;
        if (data.length >= this.state.limit) {
            const remove = data.length - this.state.limit + 1;
            data = data.slice(remove);
            labels = labels.slice(remove);
        }
        data.push(value);
        labels.push(new Date());
        this.chartData.data.datasets[0].data = data;
        this.chartData.data.labels = labels;

        const totalTime = data.reduce((sum, value) => sum + value, 0);
        const qps = totalTime > 0 ? 1000 * data.length / totalTime : 0;
        const average = data.length === 0 ? 0 : totalTime / data.length;
        const maxLatency = data.reduce((m, value) => Math.max(m, value), 0);
        const minLatency = data.reduce((m, value) => Math.min(m, value), maxLatency);

        this.references.points.current.innerText = data.length;
        this.references.qps.current.innerText = qps;
        this.references.average.current.innerText = average;
        this.references.min.current.innerText = minLatency;
        this.references.max.current.innerText = maxLatency;

        if (this.chart) {
            this.chart.update(0);
        }
        if (this.props.graph) {
            this.setState({ data: data.map(v => ({ latency: v })) });
        }
    }

    reset = () => {
        this.setState({ data: [] });
        this.chartData.data.labels = [];
        this.chartData.data.datasets[0].data = [];
        if (this.chart) {
            this.chart.update();
        }
    }

    handleLimitChange = pair => {
        this.setState({ limit: pair.value });
    }

    render() {
        return (<div>
            <Button style={{ display: 'inline' }} onClick={this.reset}>Reset</Button>
            <ul>
                <li>
                    Limit: <LazySelect value={{ value: this.state.limit, label: this.state.limit }} options={this.limitOptions} onChange={this.handleLimitChange} />
                </li>
                <li>Points: <span ref={this.references.points} /></li>
                <li>QPS: <span ref={this.references.qps} /></li>
                <li>Avg: <span ref={this.references.average} /></li>
                <li>Max: <span ref={this.references.max} /></li>
                <li>Min: <span ref={this.references.min} /></li>
            </ul>
            {
                this.props.graph && false &&
                <div style={{ width: '1280px', height: '600px', position: 'relative' }}>
                    <canvas ref={this.references.chart} />
                </div>
            }
            {
                this.props.graph &&
                <LineChart width={600} height={500} data={this.state.data}>
                    <Line type="monotone" dataKey="latency" stroke="#8884d8" />
                    <CartesianGrid stroke="#ccc" />
                    <YAxis />
                </LineChart>
            }
        </div>);
    }
}

PingGraph.propTypes = {
    target: PropTypes.string.isRequired,
    graph: PropTypes.bool,
};

class PingPage extends React.PureComponent {
    constructor(props) {
        super(props);

        this.urls = [
            "http://localhost:8080/health",
            "http://192.168.86.32:8080/health",
            "http://192.168.86.24:8080/health",
            "https://devtd.wildsky.dev/health",
            "http://wildsky-server-235744280.eu-central-1.elb.amazonaws.com/health",
            "http://wildsky-server-1085789636.ap-southeast-1.elb.amazonaws.com/health",
        ];
        this.urlOptions = this.urls.map(url => ({ value: url, label: url }));
        this.platforms = ['Android', 'IPhonePlayer'];
        this.platformOptions = this.platforms.map(platform => ({ value: platform, label: platform }));

        this.state = this.loadState();
    }

    loadState() {
        const text = window.localStorage.getItem('PingPage.state.' + this.props.page);
        if (!text) {
            return {
                url: this.urls[0],
                platform: 'Android',
                version: '1.0.33',
                edit: false,
            };
        }
        return JSON.parse(text);
    }

    componentDidUpdate() {
        window.localStorage.setItem('PingPage.state.' + this.props.page, JSON.stringify(this.state));
    }

    onChangeSelect = name => value => {
        this.setState({ [name]: value.value });
    }

    onChangeInput = name => e => {
        this.setState({ [name]: e.target.value });
    }

    onHandleSwitch = name => e => {
        this.setState({ [name]: e.target.checked });
    }

    render() {
        const params = [];
        if (this.state.platform) {
            params.push('platform=' + encodeURIComponent(this.state.platform));
        }
        if (this.state.version) {
            params.push('version=' + encodeURIComponent(this.state.version));
        }
        const target = params.length == 0 ? this.state.url : this.state.url + '?' + params.join('&');
        return (<div>
            <table style={{ width: '100%' }}>
                <tbody>
                    <tr>
                        <td>
                            Url <Switch checked={this.state.edit} onChange={this.onHandleSwitch('edit')} />
                        </td>
                        <td>
                            {
                                this.state.edit &&
                                <input value={this.state.url} onChange={this.onChangeInput('url')} />
                            }
                            {
                                !this.state.edit &&
                                <LazySelect value={{ value: this.state.url, label: this.state.url }} options={this.urlOptions} onChange={this.onChangeSelect('url')} />
                            }
                        </td>
                    </tr>
                    <tr><td>Platform</td><td><LazySelect value={{ value: this.state.platform, label: this.state.platform }} options={this.platformOptions} onChange={this.onChangeSelect('platform')} /></td></tr>
                    <tr><td>Version</td><td><input value={this.state.version} onChange={this.onChangeInput('version')} /></td></tr>
                </tbody>
            </table>
            <PingGraph key={target} target={target} graph={this.props.graph} />
        </div>);
    }
}

PingPage.propTypes = {
    page: PropTypes.string.isRequired,
    graph: PropTypes.bool,
};

export class PingTest extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = this.loadState();
    }

    loadState() {
        const text = window.localStorage.getItem('PingTest.state');
        if (!text) {
            return {
                pages: ['1'],
                graph: true,
            };
        }
        return JSON.parse(text);
    }

    componentDidUpdate() {
        window.localStorage.setItem('PingTest.state', JSON.stringify(this.state));
    }

    addPage = () => {
        this.setState({ pages: this.state.pages.concat([uuid()]) });
    }

    removePage = page => () => {
        this.setState({ pages: this.state.pages.filter(p => p != page) });
    }

    toggleField = name => () => {
        this.setState({ [name]: !this.state[name] });
    }

    render() {
        return (<div>
            <Button onClick={this.addPage}>Add Page</Button>
            <Button onClick={this.toggleField('graph')}>{this.state.graph ? 'Hide Graph' : 'Show Graph'}</Button>
            <Grid container>
                {
                    this.state.pages.map(page => (
                        <Grid item key={page} style={{ margin: '8px' }}>
                            <Card style={{ padding: '8px', minWidth: '250px' }} >
                                <h1 style={{ display: 'inline-block' }}>Ping Test</h1>
                                <Button style={{ float: "right" }} onClick={this.removePage(page)}>Remove</Button>
                                <PingPage page={page} graph={this.state.graph} />
                            </Card>
                        </Grid>
                    ))
                }
            </Grid>
        </div>);
    }
}
